import { render, staticRenderFns } from "./CreateEditFuneralHome.vue?vue&type=template&id=fa263fe0&scoped=true"
import script from "./CreateEditFuneralHome.vue?vue&type=script&lang=js"
export * from "./CreateEditFuneralHome.vue?vue&type=script&lang=js"
import style0 from "./CreateEditFuneralHome.vue?vue&type=style&index=0&id=fa263fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa263fe0",
  null
  
)

export default component.exports